import React from "react";
import { AlertCircle, type LucideIcon } from "lucide-react";

interface InlineAlertProps {
  message: React.ReactNode;
  className?: string;
  icon?: LucideIcon;
  iconClassName?: string;
}

const InlineAlert: React.FC<InlineAlertProps> = ({
  message,
  className = "",
  icon: Icon = AlertCircle,
  iconClassName = "text-red-500",
}) => {
  return (
    <div
      role="alert"
      className={`mb-4 rounded-md border border-red-200 bg-red-50 p-3 text-red-800 dark:border-red-800 dark:bg-red-900/20 dark:text-red-200 ${className}`}
    >
      <div className="flex items-center">
        <Icon className={`mr-2 h-5 w-5 ${iconClassName}`} />
        <span>{message}</span>
      </div>
    </div>
  );
};

export default InlineAlert;
